import { ITableColumn } from 'views/components/table/type';
import {
  DTAppointmentSubType,
  IDTAppointmentSubType
} from 'model/DTAppointmentSubType';
import { TableType } from 'model/tableType';
import { ILookup } from 'model/lookup';
import { sortNumerical } from 'utils/sort';
export const DT_APPOINTMENT_SUBTYPE_COLUMNS: ITableColumn[] = [
  {
    label: 'Parent Type',
    key: DTAppointmentSubType.superType,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sort(a, b, DTAppointmentSubType.superType),
      reverse: (a: TableType, b: TableType) =>
        sort(b, a, DTAppointmentSubType.superType)
    }
  },
  {
    label: 'Sub-Type Title',
    key: DTAppointmentSubType.title,
    notWrap: true,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sort(a, b, DTAppointmentSubType.title),
      reverse: (a: TableType, b: TableType) =>
        sort(b, a, DTAppointmentSubType.title)
    }
  },
  {
    label: 'Status',
    key: DTAppointmentSubType.isActive,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sortBoolean(
          (a as IDTAppointmentSubType)[DTAppointmentSubType.isActive],
          (b as IDTAppointmentSubType)[DTAppointmentSubType.isActive]
        ),
      reverse: (a: TableType, b: TableType) =>
        sortBoolean(
          (b as IDTAppointmentSubType)[DTAppointmentSubType.isActive],
          (a as IDTAppointmentSubType)[DTAppointmentSubType.isActive]
        )
    }
  },
  {
    label: 'ID',
    key: DTAppointmentSubType.id,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sortNumerical(a[DTAppointmentSubType.id]!, b[DTAppointmentSubType.id]!),
      reverse: (a: TableType, b: TableType) =>
        sortNumerical(b[DTAppointmentSubType.id]!, a[DTAppointmentSubType.id]!)
    }
  },
  { label: 'Athena Id', key: DTAppointmentSubType.athenaId },
  { label: 'Duration', key: DTAppointmentSubType.duration },
  { label: 'Salesforce Title', key: DTAppointmentSubType.salesForceMapping }
];

const sortBoolean = (a?: boolean, b?: boolean) => {
  const aVal = a ?? true;
  const bVal = b ?? true;
  return aVal === bVal ? 0 : aVal ? -1 : 1;
};

const sort = (a: TableType, b: TableType, sortField: DTAppointmentSubType) => {
  let valueA = (a as IDTAppointmentSubType)[sortField];
  let valueB = (b as IDTAppointmentSubType)[sortField];
  if (sortField === DTAppointmentSubType.superType) {
    valueA = (valueA as ILookup).value;
    valueB = (valueB as ILookup).value;
  }
  return valueA!.toString().toLowerCase() > valueB!.toString().toLowerCase()
    ? -1
    : 1;
};
